/**
 * 
 */
import { store } from './store';
import throwError from './util/throwError';
export const effects = {}//unuse

export const addEffect = effects => (name, handler) => {//unuse
  effects[name] = handler
}
//const SEP = '/';//unuse

export const effectActionCreator = (modelName,effectName,handler) =>{
    return ({data}={}) => {
        const result = handler(data);
        if(typeof result !=="function"){
            throwError('effect handler must return a function')
        }
        store.dispatch(result)
    }
}
